'use strict';

import { doAjaxFiltering } from './filter';
import { DOM } from './init';

const swiperCallback = (swiper) => {
	doAjaxFiltering({
		filter_page: swiper.activeIndex + 1,
	});
};

export const enablePaginationEvents = () => {
	document.querySelectorAll(DOM.paginationWrapper).forEach((wrapper) => {
		if (wrapper.querySelector(DOM.pagination)) {
			const swiper = wrapper.querySelector(DOM.paginationSlider).swiper;

			swiper &&
				swiper.on('slideChange', () => {
					const swiperOpen = wrapper.querySelector(DOM.paginationCenter).classList.contains('open');

					if (!swiperOpen) {
						swiperCallback(swiper);
					} else {
						swiper.on('click', () => {
							swiperCallback(swiper);
						});
					}
				});
		}
	});
};
